import React from 'react';
import { TopToolbar, RefreshButton, Toolbar, SaveButton, ListButton, ShowButton, Edit,number, SimpleForm, ArrayInput, TextField, TextInput, SimpleFormIterator, NumberInput, ReferenceField, useRecordContext, useResourceContext, regex } from 'react-admin';
import { monthList } from '../common/common';
import Card from '@mui/material/Card';
import { withStyles } from '@mui/styles';


// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditToolbar = (props) => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const EditActions = ({ permissions, basePath, data, resource }) => (
    <TopToolbar>
        <RefreshButton />
        <ListButton resource={resource} />
        <ShowButton resource={resource} record={data} />
    </TopToolbar>
)

const EditTitle = () => {
    return <span>Edit Loyalty Points</span>;
};

const editStyles = {
    root: { display: 'flex', alignItems: 'flex-start', width: '100%' },
    form: { flexGrow: 9 },
};

const FormDiv = withStyles(editStyles)(({ children, classes, basePath, ...props }) => {
    const record = useRecordContext();
    const resource = useResourceContext();
    return (
        <div className={classes.root}>
            <div className={classes.form}>
                <div className="target-edit-element-group target-edit-element-group-padding-bottom">
                    <div className="target-edit-element">
                        <label class="month" for="sold_to_code">
                            <span>Sold To Code</span>
                        </label>
                        <div>
                            <span id="month">{record.sap_code}</span>
                        </div>
                    </div>
                    <div className="target-edit-element">
                        <label class="month" for="name">
                            <span>Sold To Name</span>
                        </label>
                        <div>
                            <span id="month">{record.business_name}</span>
                        </div>
                    </div>
                </div>
                <div className="target-edit-element-group">
                    <div className="target-edit-element">
                        <label class="month" for="month">
                            <span>Month</span>
                        </label>
                        <div>
                            <span id="month">{monthList[Number(record.month) - 1]}</span>
                        </div>
                    </div>
                    <div className="target-edit-element">
                        <label class="month" for="year">
                            <span>Year</span>
                        </label>
                        <div>
                            <span id="month">{record.year}</span>
                        </div>
                    </div>
                </div>
                <div className="target-edit-element-group">
                    <span className="target-edit-element">
                        <NumberInput source="points" step={1} 
                            validate={[number(),regex(/^[0-9]*$/,"check karo")]} 
                            onKeyDown={ e => ( e.keyCode === 69 || e.keyCode === 190 ) && e.preventDefault() }
                            defaultValue={record.loyalty_points ? record.loyalty_points : 0} 
                            label="Loyalty Points" />
                        </span>
                </div>
            </div>
        </div>
    )
})

const LoyaltyPointsEdit = ({ permissions, ...props }) => {
    const noOftargets = [...Array(3).keys()];
    const record = useRecordContext();
    const resource = useResourceContext();
    return (
        <Edit actions={<EditActions permissions={permissions} />} {...props} title={<EditTitle />} undoable={false}>
            <SimpleForm toolbar={<EditToolbar />}>
                <FormDiv record={record} resource={resource} />
            </SimpleForm>
        </Edit>
    )
}


export default LoyaltyPointsEdit;
